import Error404 from "./controllers/error-404.vue";

export default {
  path: "*",
  name: "error-404",
  props: true,
  component: Error404
};
